// Service Worker registration and management

export async function registerServiceWorker() {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      })
      
      console.log('Service Worker registered successfully:', registration.scope)
      
      // Check for updates periodically
      setInterval(() => {
        registration.update()
      }, 60 * 60 * 1000) // Check every hour
      
      // Handle updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing
        
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New update available
              console.log('New content available; please refresh.')
              
              // You could show a toast notification here
              if (window.confirm('A new version is available. Refresh to update?')) {
                window.location.reload()
              }
            }
          })
        }
      })
      
      return registration
    } catch (error) {
      console.error('Service Worker registration failed:', error)
    }
  }
}

export async function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations()
    
    for (const registration of registrations) {
      await registration.unregister()
    }
    
    console.log('Service Workers unregistered')
  }
}

// Check if app is running offline
export function isOffline() {
  return !navigator.onLine
}

// Listen for online/offline events
export function setupNetworkListeners(
  onOnline?: () => void,
  onOffline?: () => void
) {
  window.addEventListener('online', () => {
    console.log('Back online')
    onOnline?.()
  })
  
  window.addEventListener('offline', () => {
    console.log('Gone offline')
    onOffline?.()
  })
  
  // Return cleanup function
  return () => {
    window.removeEventListener('online', onOnline!)
    window.removeEventListener('offline', onOffline!)
  }
}

// Request persistent storage
export async function requestPersistentStorage() {
  if (navigator.storage && navigator.storage.persist) {
    const isPersisted = await navigator.storage.persist()
    console.log(`Persistent storage ${isPersisted ? 'granted' : 'denied'}`)
    return isPersisted
  }
  return false
}

// Get storage estimate
export async function getStorageEstimate() {
  if (navigator.storage && navigator.storage.estimate) {
    const estimate = await navigator.storage.estimate()
    console.log(`Storage: ${estimate.usage} / ${estimate.quota} bytes used`)
    return estimate
  }
  return null
}